<div
  class="toggle-container noSelect cursor-pointer"
  [class.toggle-container_on]="value"
  (click)="switch()"
>
  <div class="toggle-container__label">
    <nb-icon *ngIf="offIcon" [icon]="offIcon"></nb-icon>
    <span *ngIf="offLabel">{{ offLabel | translate }}</span>
  </div>

  <div class="toggle-container__label">
    <nb-icon *ngIf="onIcon" [icon]="onIcon"></nb-icon>
    <span *ngIf="onLabel">{{ onLabel | translate }}</span>
  </div>
</div>